var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg068Pencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.14,122.982L389.517,6.36c-7.803-7.804-20.453-7.815-28.269-0.023L50.863,315.722 c-2.449,2.441-4.223,5.475-5.149,8.805L0.733,486.13c-1.94,6.97,0.035,14.445,5.164,19.548c3.801,3.781,8.895,5.823,14.11,5.823 c1.823,0,3.662-0.25,5.465-0.762l161.603-45.904c6.819-1.937,12.104-7.337,13.892-14.196s-0.186-14.152-5.19-19.172 l-42.455-42.584l224.47-224.47l29.078,29.078L237.864,361.377c-7.838,7.787-7.88,20.454-0.094,28.292 c7.785,7.838,20.452,7.88,28.292,0.094l240.031-238.441c3.772-3.748,5.898-8.843,5.907-14.16 C512.009,131.844,509.9,126.742,506.14,122.982z M48.841,462.506l26.492-95.179l68.103,68.31L48.841,462.506z M125.073,360.547 l-31.154-31.248l224.743-224.019l30.839,30.839L125.073,360.547z M435.257,165.291l-88.257-88.257l28.349-28.258l88.305,88.306 L435.257,165.291z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg068Pencil);
export default __webpack_public_path__ + "static/media/068-pencil.739ecdf3f008b1af5a49e6962950b5b2.svg";
export { ForwardRef as ReactComponent };